import React from 'react';
import { motion } from 'framer-motion';

const SliderMarks = [1, 2, 3, 4, 5];

export default function DegreeSlider({ value, onChange }) {
  return (
    <div className="my-6">
      <label className="block text-sm font-bold text-gray-700 mb-3">
        Fit Degree:
      </label>

      <div className="relative w-full h-14">
        {/* Dicke, abgerundete Bar */}
        <div className="absolute top-1/2 left-0 w-full h-10 bg-yellow-500 rounded-full -translate-y-1/2 shadow-inner" />

        {/* Zahlen-Labels direkt IN der Bar */}
        {SliderMarks.map((mark) => (
          <div
            key={mark}
            className="absolute top-1/2 text-[22px] font-semibold text-yellow-800 z-10 -translate-x-[-40px] -translate-y-1/2"
            style={{ left: `${((mark - 1) / 5) * 100}%` }}
          >
            {mark}
          </div>
        ))}

        {/* Unsichtbarer Slider */}
        <input
          type="range"
          min="1"
          max="5"
          step="1"
          value={value}
          onChange={(e) => onChange(parseInt(e.target.value))}
          className="w-full h-14 opacity-0 absolute z-20 cursor-pointer"
        />

        {/* Thumb */}
        <motion.div
          className="absolute top-[27px] w-8 h-8 bg-yellow-500 rounded-xl shadow-md border-2 border-white 
          -translate-x-[-30px] -translate-y-1/2 z-100"
          animate={{
            left: `${((value - 1) / 5) * 100}%`,
            transition: { type: 'spring', stiffness: 300, damping: 20 }
          }}
        />
      </div>
    </div>
  );
}
